(function(){
  if (window.__featuredBuyNowLoaded) return;
  window.__featuredBuyNowLoaded = true;

  function debugLog() {
    if (window && window.console && window.console.log) {
      console.log.apply(console, arguments);
    }
  }

  // Intenta agregar por AJAX (cart/add.js). Si falla, intenta fallback con form submit.
  function addToCartAjax(variantId) {
    debugLog('[BuyNow] intento AJAX /cart/add.js ->', variantId);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(resp){
      debugLog('[BuyNow] respuesta AJAX status', resp.status);
      if (!resp.ok) {
        return resp.text().then(function(text){
          var e = new Error('AJAX add failed: ' + resp.status + ' — ' + text);
          e.status = resp.status;
          e.body = text;
          throw e;
        });
      }
      return resp.json();
    });
  }

  // Fallback: crear un form temporal que postee a /cart/add (navega), luego forzar checkout.
  function addToCartByForm(variantId) {
    debugLog('[BuyNow] fallback: crear form /cart/add ->', variantId);
    try {
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/add';
      form.style.display = 'none';

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = String(variantId);
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();

      // Si el form navega, el siguiente timeout puede no ejecutarse. Igual ponemos redirect por seguridad.
      setTimeout(function(){ window.location.href = '/checkout'; }, 1200);
      return Promise.resolve({ fallback: true });
    } catch (err) {
      return Promise.reject(err);
    }
  }

  function handleClick(e) {
    var btn = (e.target && e.target.closest && e.target.closest('.featured-buy-now-btn')) || e.target;
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id') || '';
    debugLog('[BuyNow] click. data-variant-id=', variantId, 'button:', btn);

    // fallback: intentar obtener input[name="id"] dentro de la card
    if (!variantId || variantId === 'null' || variantId === 'undefined') {
      var card = btn.closest('[data-product-id], .card-wrapper, [data-product-handle]') || document;
      var input = card.querySelector('input[name="id"], input.product-variant-id');
      if (input) variantId = input.value;
      debugLog('[BuyNow] fallback variantId from input:', variantId);
    }

    if (!variantId) {
      alert('No se encontró una variante disponible para este producto. Revisa que el botón tenga data-variant-id.');
      return;
    }

    if (btn.__processing) return;
    btn.__processing = true;
    btn.disabled = true;
    var originalText = btn.innerText;
    btn.innerText = 'Redirigiendo...';

    // Primero intento AJAX; si fallo, pruebo con form submit.
    addToCartAjax(variantId)
      .then(function(json){
        debugLog('[BuyNow] add success json:', json);
        // si éxito, llevar a checkout
        window.location.href = '/checkout';
      })
      .catch(function(err){
        console.error('[BuyNow] AJAX error:', err);
        // si la variante es inválida (422), informamos
        if (err && err.status === 422) {
          alert('No se pudo agregar el producto: la variante no está disponible.');
          btn.disabled = false;
          btn.__processing = false;
          btn.innerText = originalText;
          return;
        }
        // fallback con form submit (más fiable si algo bloquea fetch)
        addToCartByForm(variantId).catch(function(formErr){
          console.error('[BuyNow] fallback form error:', formErr);
          alert('No se pudo añadir el producto al carrito. Revisa la consola para más detalles.');
          btn.disabled = false;
          btn.__processing = false;
          btn.innerText = originalText;
        });
      });
  }

  document.addEventListener('click', function(evt){
    var el = evt.target;
    if (!el) return;
    if ((el.classList && el.classList.contains('featured-buy-now-btn')) || (el.closest && el.closest('.featured-buy-now-btn'))) {
      handleClick(evt);
    }
  }, false);

  debugLog('[BuyNow] script cargado');
})();
